// extracted by mini-css-extract-plugin
export default {"gradient":"gradient_gradient__nzkqR","shine-lines":"gradient_shine-lines__NFT7i"};